<template>
  <div
    class="d-flex justify-center text-center overflow-hidden"
    :class="{ 'text-h5 text-md-h4': small, 'text-h4 text-md-h3': !small }"
  >
    <v-sheet
      class="
        accent--text
        position-relative
        px-10 px-md-14 px-lg-16
        title-widget
      "
      color="transparent"
      :min-width="xsOnly ? 'auto' : '400px'"
    >
      <slot />
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      Type: Boolean,
      default: false,
    },
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-widget {
  line-height: 1.3 !important;

  &:before,
  &:after {
    background-color: var(--v-accent-lighten2);
    content: "";
    height: 1px;
    margin-top: -0.5px;
    position: absolute;
    top: 50%;
    width: 100vw;
  }

  &:before {
    right: 100%;
  }

  &:after {
    left: 100%;
  }
}
</style>
